import { EventsModel } from '@/models/sidebar/info.model';

const marker = (date: string, db: EventsModel[]): EventsModel[] => {
  // Sort markers by location
  db = db.sort((a, b) => {
    return b.location[0] - a.location[0];
  });

  db = db.filter((item) => {
    return item.date === date;
  });

  db = db.map((currentMarker: EventsModel) => {
    return {
      _id: currentMarker._id,
      category: currentMarker.category,
      country: currentMarker.country,
      cssClass: currentMarker.cssClass,
      date: currentMarker.date,
      location: currentMarker.location,
      marker: currentMarker.marker,
      pageWeight: currentMarker.pageWeight,
      source: currentMarker.source,
      text: currentMarker.text,
      text_he: currentMarker.text_he,
      text_ar: currentMarker.text_ar,
      text_hr: currentMarker.text_hr
    };
  });

  return db;
};

export default marker;
